export default __webpack_public_path__ + "images/mela-purchase/preferred-plan-6ea81e676bbce419b299377c0455611b.png";